import React from "react"
import styled from "styled-components"
import { rem } from "polished"

import Container from "./container"

const StyledContainer = styled(Container)`
  pointer-events: none;
`

const Spacer = styled.div`
  padding-top: 7.5%;
  margin-top: ${rem(15)};
`

const LogoSpacer = () => (
  <StyledContainer>
    <Spacer />
  </StyledContainer>
)

export default LogoSpacer